import React, { Component } from 'react'
import Link from '../../../front/components/shared/sn-link'
import classnames from 'classnames'

import i18n from '../../../locales/i18n'

const landingBoxButtons = [
    {
        link: '/sportuji',
        image: '/images/landing-boxes/sportovec.png',
        text: i18n.t('landingSquareButtonsSports'),
    },
    {
        link: '/mlady-sportovec',
        image: '/images/landing-boxes/dite.png',
        text: i18n.t('landingSquareButtonsChild'),
    },
    {
        link: '/rodice-a-deti',
        image: '/images/landing-boxes/rodic.png',
        text: i18n.t('landingSquareButtonsParent'),
    },
    {
        link: '/trener-instruktor-lektor',
        image: '/images/landing-boxes/trener.png',
        text: i18n.t('landingSquareButtonsTrainee'),
    },
    {
        link: '/trenuji-tym-klub',
        image: '/images/landing-boxes/klub.png',
        text: i18n.t('landingSquareButtonsTeamsAndClubs'),
    },
    {
        link: '/organizuji-sportovni-akce',
        image: '/images/landing-boxes/organizator.png',
        text: i18n.t('landingSquareButtonsTournamentOrganizer'),
    },
    {
        link: '/fandim-sportu',
        image: '/images/landing-boxes/fandim.png',
        text: i18n.t('landingSquareButtonsFan'),
    },
    {
        link: '/vlastnim-obchod',
        image: '/images/landing-boxes/obchod.png',
        text: i18n.t('landingSquareButtonsShop'),
    },
    {
        link: '/spravuji-sportoviste',
        image: '/images/landing-boxes/sportoviste.png',
        text: i18n.t('landingSquareButtonsSportVenues'),
    },
    {
        link: '/mesta',
        image: '/images/landing-boxes/mesto.png',
        text: i18n.t('landingSquareButtonsCitiesSportnect'),
    },
]

class LandingButtons extends Component {

    render() {

        const { forSubpage } = this.props

        return (
            <div className="bg-white landing-boxes">
                <div className="container-fluid container-fluid__landing">
                    <div className="row my-4">
                        {forSubpage &&
                            <h3 className="landing px-3 my-3 font-secondary font-weight-extra-bold container font-size-lg">
                                {i18n.t('subpage.buttonsSection.title')}
                            </h3>
                        }
                        {!forSubpage &&
                            <div className="col-12 col-lg-4 white-space-pre-wrap">
                                <div className="landing-boxes__title pb-3 pl-xl-5 line-height-md font-secondary font-weight-lighter">
                                    {i18n.t('landingBoxButtons.heading')}
                                </div>
                            </div>
                        }
                        <div className={classnames({
                            'col-12': true,
                            'col-lg-8': !forSubpage,
                        })}>
                            <div className={classnames({
                                'container mb-5': forSubpage,
                            })}>
                                <div className={classnames({
                                    'pr-0 d-flex flex-wrap': true,
                                    'pr-xl-5': !forSubpage,
                                })}>
                                    {landingBoxButtons.map((boxButton, idx) => (
                                        <Link
                                            key={idx}
                                            to={boxButton?.link}
                                            className="image-link"
                                        >
                                            <div className="image-link__content">
                                                <img src={boxButton?.image} alt="" />
                                                <p className="image-link__text">
                                                    {boxButton?.text}
                                                </p>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LandingButtons
